import React from 'react';

export default function DomainValue() {
  const valueProps = [
    {
      title: "Premium .COM Extension",
      description: "The most trusted and valuable domain extension globally",
      icon: "🌐"
    },
    {
      title: "Brandable & Memorable",
      description: "Easy to remember, type, and brand across all platforms",
      icon: "🎯"
    },
    {
      title: "SEO Advantage",
      description: "Exact match keywords for combat sports search terms",
      icon: "📈"
    },
    {
      title: "Global Recognition",
      description: "Universally understood across all languages and cultures",
      icon: "🌍"
    },
    {
      title: "Industry Authority",
      description: "Instantly establishes credibility in combat sports",
      icon: "👑"
    },
    {
      title: "Marketing Gold",
      description: "Perfect for campaigns, events, and brand positioning",
      icon: "💎"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-deep-charcoal">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 md:mb-6 leading-tight tracking-tight">
            DOMAIN VALUE PROPOSITION
          </h2>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed font-light">
            WorldTitleFight.com - a strategic business asset that 
            commands respect in the combat sports industry
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16">
          {valueProps.map((prop, index) => (
            <div
              key={index}
              className="bg-gray-900/80 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-gray-700 hover:border-champagne-gold/50 transition-all duration-300 text-center group hover:shadow-2xl"
            >
              <div className="text-3xl md:text-4xl mb-3 md:mb-4 group-hover:scale-110 transition-transform duration-300">
                {prop.icon}
              </div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-2 md:mb-3 leading-tight">
                {prop.title}
              </h3>
              <p className="text-gray-300 text-sm md:text-base leading-relaxed font-light">
                {prop.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-champagne-gold/10 to-gray-800/20 rounded-2xl p-6 md:p-8 border border-champagne-gold/20">
          <div className="text-center">
            <h3 className="text-2xl md:text-3xl font-black text-white mb-3 md:mb-4 leading-tight tracking-tight">
              THE ULTIMATE COMBAT SPORTS DOMAIN
            </h3>
            <p className="text-base md:text-lg text-gray-300 mb-4 md:mb-6 max-w-2xl mx-auto leading-relaxed font-light">
              WorldTitleFight.com represents the pinnacle of combat sports branding. 
              Whether you're organizing the next big fight, streaming live events, 
              or building the future of combat sports entertainment, this domain 
              gives you the credibility and recognition you need to succeed.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6 text-base md:text-lg">
              <div className="flex items-center gap-2">
                <span className="w-3 h-3 bg-champagne-gold rounded-full"></span>
                <span className="text-champagne-gold font-semibold tracking-wide">PREMIUM ASSET</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-3 h-3 bg-white rounded-full"></span>
                <span className="text-white font-semibold tracking-wide">STRATEGIC VALUE</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-3 h-3 bg-gray-400 rounded-full"></span>
                <span className="text-gray-400 font-semibold tracking-wide">INSTANT AUTHORITY</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}